export default __webpack_public_path__ + "static/media/logical-green.f52d1e35.png";